var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8067 7.62288L20.1842 6.54279C19.6577 5.62887 18.4907 5.31359 17.5755 5.83798V5.83798C17.1399 6.09461 16.6201 6.16742 16.1307 6.04035C15.6413 5.91329 15.2226 5.59678 14.9668 5.16064C14.8023 4.88342 14.7139 4.56766 14.7105 4.24531V4.24531C14.7254 3.72849 14.5304 3.22767 14.17 2.85694C13.8096 2.4862 13.3145 2.27713 12.7975 2.27734H11.5435C11.037 2.27734 10.5513 2.47918 10.194 2.83821C9.83669 3.19724 9.63717 3.68386 9.63961 4.19039V4.19039C9.6246 5.23619 8.77248 6.07608 7.72657 6.07597C7.40421 6.07262 7.08846 5.98421 6.81123 5.81968V5.81968C5.89606 5.29528 4.72911 5.61056 4.20254 6.52448L3.53435 7.62288C3.00841 8.53566 3.3194 9.70187 4.23 10.2316V10.2316C4.8219 10.5733 5.18653 11.2049 5.18653 11.8883C5.18653 12.5718 4.8219 13.2033 4.23 13.5451V13.5451C3.32056 14.0712 3.00923 15.2346 3.53435 16.1446V16.1446L4.16593 17.2339C4.41265 17.679 4.8266 18.0076 5.31619 18.1467C5.80578 18.2859 6.33064 18.2242 6.77462 17.9753V17.9753C7.21108 17.7206 7.73119 17.6508 8.21934 17.7815C8.70749 17.9121 9.12324 18.2323 9.37416 18.6709C9.5387 18.9482 9.62711 19.2639 9.63046 19.5863V19.5863C9.63046 20.6428 10.487 21.4993 11.5435 21.4993H12.7975C13.8505 21.4993 14.7055 20.6484 14.7105 19.5954V19.5954C14.7081 19.0873 14.9089 18.5993 15.2682 18.24C15.6275 17.8807 16.1155 17.6799 16.6236 17.6824C16.9452 17.691 17.2596 17.779 17.5389 17.9387V17.9387C18.4517 18.4646 19.6179 18.1536 20.1476 17.243V17.243L20.8067 16.1446C21.0618 15.7068 21.1318 15.1853 21.0012 14.6956C20.8706 14.206 20.5502 13.7886 20.111 13.5359V13.5359C19.6718 13.2832 19.3514 12.8658 19.2208 12.3762C19.0902 11.8866 19.1603 11.3651 19.4154 10.9272C19.5812 10.6376 19.8214 10.3975 20.111 10.2316V10.2316C21.0161 9.70216 21.3264 8.54276 20.8067 7.63203V7.63203V7.62288Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1751,
    cy: 11.8881,
    r: 2.63616,
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.4f8fdf69593238c3c4830049650437e7.svg";
export { ForwardRef as ReactComponent };